import React from 'react';
import { CommonPageStep } from '..';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/ForgetEmail.desktop';
import { MobileView } from './mobile/ForgetEmail.mobile';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';
import { Login } from '../login';

export const ForgetEmail = (): JSX.Element => {
  // Redux Hooks
  const appPageStep = useAppSelector(selectAppPageStep);

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(CommonPageStep.FORGETEMAIl));
  }, []);

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
      {appPageStep === CommonPageStep.LOGIN ? <Navigate to="/Login" /> : null}
    </React.Fragment>
  );
};
